import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
    PreviewImageDialogComponent
} from '@emm/common-items/dialogs/preview-image-dialog/preview-image-dialog.component';
import {ItemDataService} from './services/item-data.service';
import {EffectiveDateService} from './services/effective-date.service';
import {MatTooltip} from '@angular/material/tooltip';
import {CommonItemComponent} from '@emm/common-items/components/common-item/common-item.component';
import {CommonItemDetailsComponent} from '@emm/common-items/components/common-item-details/common-item-details.component';
import {FindAttributePipe} from '@emm/shared/pipes/find-attribute.pipe';
import {MatTableModule} from '@angular/material/table';
import {FilterKeyPipe} from '@emm/shared/pipes/filter-key.pipe';
import {ClassTypeChipsComponent} from '@emm/common-items/components/class-type-chips/class-type-chips.component';
import {ComponentsCardComponent} from '@emm/common-items/components/components-card/components-card.component';
import {OverridesCardComponent} from '@emm/common-items/components/overrides-card/overrides-card.component';
import {AssignmentsCardComponent} from '@emm/common-items/components/assignments-card/assignments-card.component';
import {SharedModule} from '@emm/shared/shared.module';
import {
    ValueOverridesCardComponent
} from '@emm/common-items/components/value-overrides-card/value-overrides-card.component';
import {
    CreatedDateComponent
} from '@emm/common-items/components/created-date/created-date.component';
import {
    UpdatedDateComponent
} from '@emm/common-items/components/updated-date/updated-date.component';
import {
    AttributeOverrideDetailDialogComponent
} from '@emm/common-items/dialogs/attribute-override-detail-dialog/attribute-override-detail-dialog.component';

@NgModule({
    declarations: [
        CommonItemDetailsComponent,
        PreviewImageDialogComponent,
        CommonItemComponent,
        FindAttributePipe,
        FilterKeyPipe,
        ClassTypeChipsComponent,
        ComponentsCardComponent,
        OverridesCardComponent,
        AssignmentsCardComponent,
        ValueOverridesCardComponent,
        CreatedDateComponent,
        UpdatedDateComponent,
        AttributeOverrideDetailDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatSelectModule,
        MatTabsModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatChipsModule,
        DragDropModule,
        MatTooltip,
        MatTableModule,
        SharedModule,
        NgOptimizedImage,
    ],
    providers: [
        ItemDataService,
        EffectiveDateService,
    ],
    exports: [
        CommonItemDetailsComponent,
        CommonItemComponent,
        ClassTypeChipsComponent,
        ComponentsCardComponent,
        OverridesCardComponent,
        AssignmentsCardComponent,
        ValueOverridesCardComponent,
        CreatedDateComponent,
        UpdatedDateComponent,
        AttributeOverrideDetailDialogComponent,
    ]
})
export class CommonItemsModule {
}
